import { render, staticRenderFns } from "./StudentsInCantonForSchoolYear.vue?vue&type=template&id=5edbbcc9&scoped=true"
import script from "./StudentsInCantonForSchoolYear.vue?vue&type=script&lang=js"
export * from "./StudentsInCantonForSchoolYear.vue?vue&type=script&lang=js"
import style0 from "./StudentsInCantonForSchoolYear.vue?vue&type=style&index=0&id=5edbbcc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edbbcc9",
  null
  
)

export default component.exports